import { Project, TimeType } from "./project";
import { User } from "./user";

export class TimeEntry {
    id?: number;
    userId?: number;
    projectId?: number;
    recordedTime?: number;
    dateEntry?: string;
    notes?: string;
    isPleaseReview?: boolean;
    timeTypeId: number | undefined;
    timeType?: TimeType;

    timesheet?: TimeSheet;
    project?: Project;
}

/** One category of official leave for a timesheet's week, as attached by the API. */
export interface OfficialLeaveSummary {
    category: 'Vacation' | 'Other' | string;
    /** Approved leave hours for the week. */
    hours: number;
    /** Approved leave hours per day, Sunday (weekStart) through Saturday. */
    dailyHours: number[];
    // Requested hours may describe the same leave as approved hours and are not shown.
    requestedHours: number;
    dailyRequestedHours: number[];
}

export class TimeSheet {
    id?: number;
    weekStart?: string;
    timeEntries?: TimeEntry[];
    status?: TimesheetStatus;
    reviewerComments?: string;
    owner?: User;
    /** Empty when the API couldn't look up leave for a week that needs it. */
    officialLeave?: OfficialLeaveSummary[];
    /** Set by mergeOfficialLeave when a week needs official leave but none was attached. */
    officialLeaveUnavailable?: boolean;

    ui?: TimeSheetUI;
}

export class TimeSheetUI {
    isExpanded?: boolean = false;
    isSelected?: boolean = false;
}

export enum TimesheetStatus {
    Unsubmitted = "Unsubmitted",
    Submitted = "Submitted",
    Approved = "Approved",
    Review = "Review"
}
